export default "__VITE_ASSET__Bb95kebi__"